import { lazy, Suspense } from 'react';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
// Public courier proof-of-delivery capture (#106, PRD #108).
//
// `/courier/capture/:token` is a top-level route that is a sibling of the portal
// routes but lives entirely OUTSIDE `AuthGuard` (mirroring the anonymous
// `portal/:agencySlug` landing). It must render with NO Auth0 login — the URL
// token is the only credential — so it deliberately has no guard and no app
// shell/nav around it; the page provides its own standalone mobile chrome.
// ----------------------------------------------------------------------

const CourierCapturePage = lazy(() => import('src/pages/courier/capture'));

export const courierRoutes = [
  {
    path: 'courier/capture/:token',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <CourierCapturePage />
      </Suspense>
    ),
  },
];
